// Vue
import { Component } from "vue-property-decorator";
// Template
import template from "./template.vue";
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { AufbauplusHeadline } from "#/components/aufbauplus_headline/AufbauplusHeadline";
import ModuleBase from "#/common/ModuleBase";

@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    AufbauplusHeadline,
  },
})
export class TypeC extends ModuleBase {
  getBackgroundColorFromInstance(instance: object) {
    return instance["background"];
  }

  get headlineBackgroundColor() {
    return this.backgroundColor == "black" ? "black" : "white";
  }
}
